<div class="box">
  <div class="box-title">
    {{ 'Communication_between_coaches' | translate }}
    <button mat-mini-fab
            color="none"
            class="more-button"
            [matTooltip]="'CommunicationsAll' | translate"
            [routerLink]="'/' + organization.code + '/athletes/' + athleteUser.id + '/communications'"
    >
      <mat-icon color="primary">zoom_in</mat-icon>
    </button>
  </div>
  <div class="box-content">
    <mat-spinner [diameter]="30" *ngIf="isLoading; else boxContent"></mat-spinner>
  </div>
</div>

<ng-template #boxContent>
  <ng-container *ngIf="organization">

    <ng-container *ngFor="let observation of (observations | slice:0:2)" class="line">
      <div class="msg">
        <div class="bubble" [class.me]="false">
          <div class="txt">
            <div class="text-title">
              <span class="name">{{ observation.author.firstName }} {{ observation.author.lastName }}</span>
              <span class="timestamp">{{ observation.updated_at | appDate:'dd MMM yyyy':'':currentLang }}</span>
            </div>
            <div class="message" [innerHTML]="observation.message | emojify"></div>
          </div>
          <div class="bubble-arrow"></div>
        </div>
      </div>
      <ng-container *ngFor="let comment of observation.comments" class="line">
        <div class="msg">
          <div class="bubble" [class.me]="true">
            <div class="txt">
              <span class="name">{{ comment.author.firstName }} {{ comment.author.lastName }}</span>
              <span class="timestamp">{{ comment.updated_at | dateClosest | lowercase }}</span>
              <div class="message" [innerHTML]="comment.message | emojify"></div>
            </div>
            <div class="bubble-arrow"></div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <div *ngIf="observations.length > 2">+ {{ observations.length-2 }} {{ 'CommunicationsRemaining' | translate }}</div>

    <div class="box-input">
      <mat-form-field color="primary">
                <textarea matInput
                          mat-autosize
                          #messageInput
                          [formControl]="observationForm"
                          type="text"
                          maxlength="{{ OBSERVATION_MAX_LENGTH }}"
                          [placeholder]="'Write_Communication' | translate"
                          rows="2">
                </textarea>
        <button
          mat-suffix
          mat-icon-button
          color="accent"
          matTooltip="{{ 'Send' | translate }}"
          [disabled]="observationForm.value?.length == 0"
          (click)="onNewObservationClicked()">
          <i class="material-icons">
            send
          </i>
        </button>
      </mat-form-field>

    </div>
  </ng-container>

</ng-template>
